var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useContext, useMemo } from 'react';
import wrapTWithDefaultNs from './wrapTWithDefaultNs';
import I18nContext from './context';
import transCore from './transCore';
function useTranslationInPages(defaultNS) {
    var ctx = useContext(I18nContext);
    return useMemo(function () { return (__assign(__assign({}, ctx), { t: wrapTWithDefaultNs(ctx.t, defaultNS) })); }, [ctx, defaultNS]);
}
function useTranslationAppDir(defaultNS) {
    var _a = globalThis.__NEXT_TRANSLATE__ || {}, lang = _a.lang, namespaces = _a.namespaces;
    var localesToIgnore = globalThis.i18nConfig.localesToIgnore || ['default'];
    var ignoreLang = localesToIgnore.includes(lang);
    var t = transCore({
        config: globalThis.i18nConfig,
        allNamespaces: namespaces,
        pluralRules: new Intl.PluralRules(ignoreLang ? undefined : lang),
        lang: lang,
    });
    return { t: wrapTWithDefaultNs(t, defaultNS), lang: lang };
}
export default function useTranslation(defaultNS) {
    var isAppDir = !!globalThis.__NEXT_TRANSLATE__;
    var useT = isAppDir ? useTranslationAppDir : useTranslationInPages;
    return useT(defaultNS);
}
